/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import Logo from 'assets/images/footer-logo-tm.png';
import Instagram from 'assets/svg/instagram.svg';
import Facebook from 'assets/svg/facebook.svg';
import LinkedIn from 'assets/svg/linkedin.svg';
import { CTALink, ContactForm, ScrollTop } from 'components';

export const Footer = ({ footer, socialMediaLinks }: any) => {
  const {
    footerNav,
    location,
    formEmbedCode,
    subscribeformTitle,
    subscribeformtagline,
  } = footer;
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-section">
          <div className="footer-section-column">
            <div className="footer-section-contact">
              <h3 className="subscribe-title">
                {subscribeformTitle || 'Subscribe'}
              </h3>
              <div className="subscribe-tagline">
                {subscribeformtagline ||
                  'Join the Tastyone family and stay updated'}
              </div>
              <ContactForm
                embedCode={formEmbedCode}
                formId="hubspot-footer-form-container"
                className="subscribe-form"
              />
            </div>
            <div className="logo">
              <CTALink ctaLink="/" className="footer-logo">
                <img src={Logo} alt="TastyOne" />
              </CTALink>
            </div>
          </div>

          <div className="footer-section-column two">
            <div className="footer-page-links">
              <div className="footer-page-links-section one">
                <ul className="footer-links">
                  {footerNav.map((nav: any) => (
                    <li key={nav.id}>
                      <CTALink ctaLink={nav.slug}>{nav.title}</CTALink>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="footer-section-address">
              <div className="location">
                <h4>Location:</h4>
                <p>{location.data.location}</p>
              </div>

              <div className="icons">
                <h4>Follow Us</h4>
                <ul className="social-icons">
                  <li>
                    <a
                      target="_blank"
                      href={socialMediaLinks?.instagramLink}
                      rel="noreferrer"
                    >
                      <Instagram />
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href={socialMediaLinks?.facebookLink}
                      rel="noreferrer"
                    >
                      <Facebook />
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href={socialMediaLinks?.linkedinLink}
                      rel="noreferrer"
                    >
                      <LinkedIn />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-credits">
          Designed by{' '}
          <a href="https://lovemark.com.au/" target="_blank">
            Lovemark
          </a>{' '}
          and built by{' '}
          <a href="https://ozzi.tech/" target="_blank">
            Ozzitech
          </a>
        </div>
      </div>
      <ScrollTop />
    </footer>
  );
};
